import {Component, Prop, Vue} from "vue-property-decorator";
import { getFileSrc } from "~/lib/helpers";

export type LogoConfig = {
  fileId:string;
  width?:string;
};

@Component
export class Logo extends Vue {
  @Prop({type: Object, required:true}) logo:LogoConfig;

  render() {
    return (
      <div class="logo" style={{width: this.logo.width}}>
        <img src={`${getFileSrc(this.logo.fileId)}`} alt="Logo"/>
      </div>
    );
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-7dfc6797/logo.tsx" });